import aboutIcon from './about.png';
import attendeesIcon from './attendees.png';
import bookmarksIcon from './bookmarks.png';
import communityIcon from './community.png';
import exhibitorsIcon from './exhibitors.png';
import galleryIcon from './gallery.png';
import gamificationIcon from './gamification.png';
import mapsIcon from './maps.png';
import meetingsIcon from './meetings.png';
import newsIcon from './news.png';
import messagesIcon from './messages.png';
import notesIcon from './notes.png';
import notificationsIcon from './notifications.png';
import scheduleIcon from './schedule.png';
import speakersIcon from './speakers.png';
import sponsorsIcon from './sponsors.png';
import socialIcon from './social.png';
import surveyIcon from './survey.png';
import webviewIcon from './webview.png';

export default {
  about: aboutIcon,
  attendees: attendeesIcon,
  bookmarks: bookmarksIcon,
  community: communityIcon,
  exhibitors: exhibitorsIcon,
  gallery: galleryIcon,
  gamification: gamificationIcon,
  maps: mapsIcon,
  meetings: meetingsIcon,
  news: newsIcon,
  messages: messagesIcon,
  notes: notesIcon,
  notifications: notificationsIcon,
  schedule: scheduleIcon,
  sponsors: sponsorsIcon,
  social: socialIcon,
  speakers: speakersIcon,
  survey: surveyIcon,
  webview: webviewIcon
};
